// extracted by mini-css-extract-plugin
export default {"downloadAll":"CollectionYardDetailPage_downloadAll__38wYE"};